import React, { useEffect } from "react";
import useProfiles from "../../hooks/useProfiles";

export default function ProfilesInitializer() {
  const { getUserProfiles } = useProfiles();

  useEffect(() => {
    const fetchUserProfiles = async () => {
      getUserProfiles();
    };

    fetchUserProfiles();
  }, []);

  return <></>;
}
